export const LOADS = '/loads';
export const SEARCHLOADS = '/searchloads';
export const BROKERS = '/brokers';
export const LANDING = '/landing';
// export const DIRECTIONS = '/directions';
export const JOBTITLE = '/job-title';
export const ALERT = '/alert';
export const ALERTURL = {
  AddAlert: 'add',
  AlertList: 'list',
  UpdateAlert: 'update',
  LoadsList: 'alert-loads'
}

export const MYACCOUNT = '/my-account';
export const MYACCOUNTURL = {
  accountProfile: 'account-profile',
  membershipManage: 'membership-manage',
  paymentHistory: 'payment-history',
  paymentSetting: 'payment-setting',
  dotVerify: 'dot-verify',
};
export const FREEACCOUNTURL = {
  dotVerify: 'dot-verify',
};
export const PAYMENT = {
  paymentProcess: '/hp',
  BasicInformation: 'basic-information',
  ProductSelection: 'product-selection',
  HpBillingInformation: 'billing-information',
  Payment: 'payment',
};
export const SIMPLEPAYMENT = '/payment'
export const USERACCOUNT = '/user-account';
export const ACCOUNT = '/account'
export const FREEACCOUNT = '/free-account';
export const PendingPayment = '/pending-payment';
export const Result = '/result';

export const MYLOADS = '/my-loads';
export const MYCOMPANY = '/my-company';

export const TOS = '/terms-of-service';
export const PRIVACY = '/privacy-policy';

export const CREATEACCOUNT = '/create-account';
export const CreatePayment = '/create-payment';
export const CreatePendingPayment = '/create-pending-payment';
export const CreatePaymentResult = '/create-payment-result';

export const RATECHECK = '/rate-check';
export const FUELSURCHARGE ='/fuel-surcharge'
export const RATEINSPECTION = '/info/rate-inspection';
export const LOADRATIO = '/info/load-ratio';
export const CALCULATOR = '/info/calcuator';
export const INFO = '/info';
export const CAPACITYRATIO = '/capacity-ratio'
export const POSTTRUCk = '/post-truck'

export const WELCOMEPROCESS = '/welcome-process'
export const WELCOMEBACKPROCESS = '/welcomeback-process'

export const UPLOADW9 = '/uploadW9ByEmail'

export const UPLOADLOADSMART = '/uploadLoadsmart'

export const MESSAGE = '/message'

export const EMAILCAMPAIGN = '/emailCampaign'

export const MEMBERSHIP = '/membership'

export const ORDERPAGE = '/orderpage'

export const EMAILCAMPAIGNNEW = '/emailCampaignNew'
export const CAPACITYRATIOMAPLIST = '/capacity-ratio-map-list'

export const MEMBERSHIPPLANS = '/membership-plans'



// WEBPACK FOOTER //
// ./src/routing/urls.js